import React from 'react';
import { usePWA } from '@/hooks/usePWA';

const PWAInstallButton: React.FC = () => {
  const { isInstallable, isInstalled, installApp } = usePWA();

  if (isInstalled) {
    return (
      <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mb-4">
        <div className="flex items-center">
          <i className="fas fa-check-circle mr-2"></i>
          <span>Application installée</span>
        </div>
      </div>
    );
  }

  if (!isInstallable) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded-lg mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <i className="fas fa-download mr-2"></i>
          <span>Installer l'application sur votre appareil</span>
        </div>
        <button
          onClick={installApp}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm"
        >
          Installer
        </button>
      </div>
    </div>
  );
};

export default PWAInstallButton;
